export const MFA_PROVIDERS = {
  google: "GOOGLE_AUTHENTICATOR",
  sms: "SMS",
  notSetup: "MFA_NOT_SETUP"
}
